import { TYPO } from "styles/Typo";
import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ActiveRadioIcon, InactiveRadioIcon } from "../util/Icon";
import { SurveyTitle } from "../util/component";
import { groupSurveyMeta } from "utils/portfolio/surveyMeta";

interface Step4Props {
  selectedOption: string;
  onOptionSelect: (option: string) => void;
  surveyList: any;
}

export default function Step3({
  selectedOption,
  onOptionSelect,
  surveyList,
}: Step4Props) {
  const optionRefs = useRef<Array<HTMLDivElement | null>>([]);
  const meta = groupSurveyMeta(surveyList);
  const metaOptions = meta["retire_timing"]?.options?.map((o) => ({
    id: o.answer_id,
    label: o.answer,
  }));
  const options = metaOptions || [
    {
      id: "retire_after_3y",
      label: "3년 후",
    },
    {
      id: "retire_after_5y",
      label: "5년 후",
    },
    {
      id: "retire_after_7y",
      label: "7년 후",
    },
    {
      id: "retire_after_10y",
      label: "10년 후",
    },
  ];

  useEffect(() => {
    const tl = gsap.timeline();
    const elements = optionRefs.current.filter(
      (el): el is HTMLDivElement => !!el
    );

    tl.fromTo(
      elements,
      {
        opacity: 0,
        x: (index: number) => 15 + index * 10,
      },
      {
        opacity: 1,
        x: 0,
        duration: 0.8,
        ease: "easeInOut",
        stagger: 0.1,
      },
      "+=0.2"
    );
  }, []);

  return (
    <div className="bg-background relative w-full   ">
      {/* Question Container */}
      <div className="content-stretch flex flex-col items-start justify-start w-full">
        {/* <SurveyTitle text={"은퇴는 언제 하시나요?"} /> */}
        <div className="pt-4 px-6 space-y-1">
          <p className={`${TYPO.TYPO7_MD} text-blue50`}>
            노후 자금을 쓰기 시작할
          </p>
          <p
            className={` w-full text-[26px] leading-[140%] font-[600]  text-gray90 whitespace-pre-line`}
          >
            은퇴는 언제 하시나요?
          </p>
        </div>

        {/* Options Container */}
        <div className="box-border content-stretch flex flex-col items-start justify-center px-6 py-4 relative shrink-0 w-full overflow-x-hidden">
          {options.map((option, index) => (
            <div
              key={index}
              ref={(el) => {
                optionRefs.current[index] = el;
              }}
              className="box-border content-stretch flex gap-2 items-center justify-start px-1 py-2.5 relative shrink-0 w-full cursor-pointer"
              onClick={() => onOptionSelect(option.id)}
              data-testid={`saa-retire-survey-step3-${option.id}-btn`}
              data-gtm-id={`saa-survey-timing-btn`}
            >
              {/* Radio Button */}
              <div className="relative shrink-0 size-5">
                <div className="absolute inset-[8.333%]">
                  {selectedOption === option.id ? (
                    <ActiveRadioIcon />
                  ) : (
                    <InactiveRadioIcon />
                  )}
                </div>
              </div>

              {/* Option Label */}
              <div
                className={`basis-0 grow min-h-px min-w-px ${
                  selectedOption === option.id ? "text-blue50" : "text-gray80"
                } ${TYPO.TYPO5_1_MD}`}
              >
                {option.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
